module.exports = __webpack_public_path__ + "img/kristina-n-berge.4badf9b2.png";